export default __webpack_public_path__ + "static/media/BackgroundLogin.92635343.png";